if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.button = this.querySelector('[data-sticky-atc-button]');
        this.label = this.querySelector('[data-sticky-atc-label]');
        this.priceEl = this.querySelector('[data-sticky-atc-price]');
        this.spinner = this.querySelector('.loading-overlay__spinner');
        this.defaultLabel = this.label ? this.label.textContent.trim() : '';
      }

      connectedCallback() {
        this.submitButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.mainPrice = document.getElementById(`price-${this.sectionId}`);
        this.trigger = this.submitButton ? this.submitButton.closest('.product-form__buttons') : null;

        if (!this.submitButton || !this.trigger) {
          return;
        }

        this.button.addEventListener('click', this.onClick.bind(this));

        this.syncPrice();
        this.syncState();
        this.syncLoading();
        this.observeChanges();
        this.observeVisibility();

        this.removeAttribute('hidden');
        this.publishHeight();
        window.addEventListener('resize', this.publishHeight.bind(this));
      }

      // Expose the bar height so fixed third-party widgets (the Podium "Text us"
      // bubble) can be lifted clear of it instead of covering Add to Cart.
      publishHeight() {
        const height = Math.round(this.getBoundingClientRect().height);
        if (height) {
          document.documentElement.style.setProperty('--sticky-atc-height', `${height}px`);
        }
      }

      onClick(event) {
        event.preventDefault();
        if (this.button.hasAttribute('disabled')) return;
        this.submitButton.click();
      }

      syncPrice() {
        if (!this.mainPrice || !this.priceEl) return;
        const onSale = this.mainPrice.querySelector('.price--on-sale') || this.mainPrice.classList.contains('price--on-sale');
        const source = onSale
          ? this.mainPrice.querySelector('.price__sale .price-item--sale')
          : this.mainPrice.querySelector('.price__regular .price-item--regular');
        const fallback = this.mainPrice.querySelector('.price-item--regular');
        const priceNode = source || fallback;
        if (priceNode) {
          this.priceEl.textContent = priceNode.textContent.trim();
        }
      }

      // Mirror the disabled / sold-out state of the real submit button.
      syncState() {
        const disabled =
          this.submitButton.hasAttribute('disabled') ||
          this.submitButton.getAttribute('aria-disabled') === 'true';

        if (disabled) {
          this.button.setAttribute('disabled', '');
          const soldOutText = this.submitButton.querySelector('span')?.textContent.trim();
          if (soldOutText && this.label) this.label.textContent = soldOutText;
        } else {
          this.button.removeAttribute('disabled');
          if (this.label) this.label.textContent = this.defaultLabel;
        }
      }

      // Mirror the loading state of the real submit button, which lives
      // off-screen whenever the sticky bar is showing.
      syncLoading() {
        const loading = this.submitButton.classList.contains('loading');
        this.button.classList.toggle('is-loading', loading);
        this.spinner?.classList.toggle('hidden', !loading);
      }

      observeChanges() {
        this.mutationObserver = new MutationObserver(() => {
          this.syncPrice();
          this.syncState();
          this.syncLoading();
        });
        if (this.mainPrice) {
          this.mutationObserver.observe(this.mainPrice, { childList: true, subtree: true, characterData: true });
        }
        this.mutationObserver.observe(this.submitButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          subtree: true,
        });
      }

      observeVisibility() {
        this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.classList.toggle('is-visible', !entry.isIntersecting);
            });
          },
          { rootMargin: '0px', threshold: 0 }
        );
        this.intersectionObserver.observe(this.trigger);
      }

      disconnectedCallback() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
      }
    }
  );
}
